import { Analytics } from '@cobliteam/analytics';

import { Location, type UUID } from '@cobliteam/common-types';
import { Button } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { Link } from 'react-router-dom';

interface ButtonMediaDetailsProps {
  mediaId: UUID;
  location?: Location;
}

const ButtonMediaDetails = ({ mediaId, location = Location.CAMERA_EVENTS_DETAILS }: ButtonMediaDetailsProps) => {
  const onClick = () => {
    Analytics.track('Video Details Modal Button Clicked');
  };

  return (
    <Link onClick={onClick} to={{ pathname: location.replace(':mediaId', mediaId!) }} target='_blank'>
      <Button onClick={onClick} variant='ghost' size='sm' startIcon={<Icon name='external-link' />}>
        Ir para detalhes do vídeo
      </Button>
    </Link>
  );
};
export default ButtonMediaDetails;
